import {
    utcToZonedTime,
    zonedTimeToUtc,
    getTimezoneOffset,
    format,
} from 'date-fns-tz';

// models
import { SearchableSelectType } from '../components/inputs/searchableSelect';

// constants
import { TimeZones } from '../constants/timeZones';

const convertMSecsToHoursMinutes = (milliSecond: number): string => {
    const totalMinutes = Math.abs(milliSecond) / 60000;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);

    const sign = milliSecond < 0 ? '-' : '+';

    return `${sign}${hours?.toString()?.padStart(2, '0')}:${minutes
        ?.toString()
        ?.padStart(2, '0')}`;
};

export const getTimeZoneOptions = (): SearchableSelectType[] => {
    return Object.keys(TimeZones).map((timezone) => {
        const offset = getTimezoneOffset(timezone);
        const value = convertMSecsToHoursMinutes(offset);
        return {
            value: timezone,
            label: `${(TimeZones as any)[timezone]} (UTC ${value})`,
        };
    });
};

export const getZonedTimeToUtcTime = (
    timezone: string,
    selectedTime: Date,
): string | null => {
    if (!selectedTime) {
        return null;
    }
    const utcTime = zonedTimeToUtc(selectedTime, timezone).toISOString();
    return utcTime.slice(0, -5);
};

export const getUtcTimeToZonedTime = (
    timezone: string,
    sendTime: string,
): Date => {
    return utcToZonedTime(sendTime, timezone);
};

export const getUtcToZonedFormattedDate = (
    timezone: string,
    sendTime: string,
    formatValue: string = 'MMMM d, yyyy, HH:mm',
): string => {
    if (!sendTime) {
        return '-';
    }
    const zonedTime = getUtcTimeToZonedTime(timezone, sendTime);
    return format(zonedTime, formatValue);
};
